/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class ContractConfirmationController {
        public static $inject: string[] = [
            '$dealerwareContractFactory',
            '$dealerwareNotification',
            '$dealerwareLoading',
            '$stateParams',
            '$state',
            '$mobilityCompanyAuthentication',
            'SettingsLoanerAgreementUploadService',
            'PdfHelperService',
            '$filter'
        ];

        public contract: any;

        constructor(public $dealerwareContractFactory: any,
                    public $dealerwareNotification: any,
                    public $dealerwareLoading: any,
                    public $stateParams: any,
                    public $state: any,
                    public $auth: any,
                    public SettingsLoanerAgreementUploadService: any,
                    public PdfHelperService: any,
                    public $filter: any) {
            this.loadContract(this.$stateParams.contractId);
        }

        public loadContract(id: number) {
            if (id) {
                var loader = this.$dealerwareLoading.show('Loading...');
                this.$dealerwareContractFactory.loadContract(this.$auth.location.id, id).then(
                    (response: any) => {
                        this.contract = response.contract;
                        loader.close();
                    },
                    (response: any) => {
                        loader.close();
                        this.$dealerwareNotification.apiError(response);
                    }
                );
            }
        }

        public goToDetails() {
            this.$state.go('shortcuts.contractDetails', { contractId: this.contract.contractDetails.data.id });
        }

        public viewLoanerAgreement() {

            var loader = this.$dealerwareLoading.show('Loading...');

            this.contract.DealerwareContractModel.getLoanerAgreementPdf(this.contract)
                .then( (response: any) => {
                    this.PdfHelperService.streamPdfToNewWindow(response.data);
                })
                .catch( (response: any) => {
                    this.$dealerwareNotification.apiError(
                        response.message ? response : 'Driver Agreement couldn\'t be opened'
                    );
                })
                .finally( ( ) => {
                    loader.close();
                });
        }

        public bookAgain() {
            this.$state.go('shortcuts.contractCreate');
        }
    }

    getDealerwareWebContentModule().controller('ContractConfirmationController', ContractConfirmationController);
}
